import { type UseQueryResult, useQuery } from 'react-query';
import { CompanyService } from '../../services/wealthlane-customer-services';

const useGetCompanyListOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const companyOptions = useQuery(
    ['getCompanyList'],
    async () => {
      return await handleRequest(CompanyService.getApiCustomerApiAppCompanyCompanies());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return companyOptions;
};

export default useGetCompanyListOptions;
